import {ColourMod, ColourSolid} from "../../Data/Enums/LayoutEnums";

export enum PillSize {
    Small = 'pill-sm',
    Medium = 'pill-md',
    Large = 'pill-lg'
}

export interface PillType {
    content: any;
    title?: string;
    size?: PillSize,
    colour?: ColourSolid | ColourMod;
}

export interface PillSquareType extends PillType {
    colour?: ColourMod;
}